import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import ArrowDropDown from '@mui/icons-material/ArrowDropDown'
import {
	StyledDivider,
	NavContainer,
	MenuWrapper,
	NavToolbar,
	StyledMenu,
	MenuItem,
} from '../StyledComponents'
import { navData } from '../data'

function NavMenu() {
	const history = useHistory()
	const [anchorEl, setAnchorEl] = useState(null)
	const open = Boolean(anchorEl)
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}
	const handleClose = () => {
		setAnchorEl(null)
	}
	const handleBtnClick = url => {
		console.log(url)
		return url ? history.push(url) : null
	}

	return (
		<MenuWrapper component="nav">
			<NavContainer>
				<NavToolbar>
					{navData.map(menu => (
						<React.Fragment key={menu.label + menu.url}>
							<MenuItem
								{...(menu.label === 'Home' && {
									color: 'warning',
									variant: 'contained',
									disableElevation: true,
								})}
								{...(menu.subMenu ? {
									...(open && { 'aria-controls': 'sub-menu' }),
									...(open && { 'aria-expanded': 'true' }),
									'aria-haspopup': "true",
									onClick: handleClick,
									id: 'menu-button',
									endIcon: <ArrowDropDown />,
								} : {
									onClick: (event) => {
										handleBtnClick(menu.url)
										handleClick(event)
									}
								})}
							>
								{menu.label}
							</MenuItem>

							<StyledDivider orientation="vertical" />

							{menu.subMenu && (
								<StyledMenu
									id='sub-menu'
									anchorEl={anchorEl}
									open={open}
									onClose={handleClose}
									MenuListProps={{
										'aria-labelledby': 'menu-button',
									}}
								>
									{menu.subMenu.map(sub => (
										<MenuItem
											onClick={(event) => {
												handleBtnClick(sub.url)
												handleClose(event)
											}}
											key={sub.label + sub.url}
										>
											{sub.label}
										</MenuItem>
									))}
								</StyledMenu>
							)}
						</React.Fragment>
					))}
				</NavToolbar>
			</NavContainer>
		</MenuWrapper>
	)
}

export default NavMenu
